import { WidgetProvider } from '@/state/WidgetContext';
import Widget from '@/components/Widget/Widget';

/**
 * App.jsx
 * Оборачивает виджет в провайдер состояния.
 * На WordPress этот уровень заменяется прямым рендером Widget в корень.
 */
export default function App() {
  return (
    <WidgetProvider>
      <Widget />
    </WidgetProvider>
  );
}
